module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(3);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var React = __webpack_require__(0);

var PropTypes = __webpack_require__(1);

var classNames = __webpack_require__(4);

var LazyLoading = __webpack_require__(5);

var ImagePreload = __webpack_require__(7);

var DEFAULT_SRC = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
var LAZYLOAD_CLASS = 'lazy-loadable';
var ONLOAD_CLASS = 'onload-loadable';
var LAZYLOAD = 'lazy';
var ONLOAD = 'onload';

var _ref2 = /*#__PURE__*/_jsx(LazyLoading, {}, "lazy-loading");

var Img = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Img, _React$PureComponent);

  var _super = _createSuper(Img);

  function Img(props) {
    var _this;

    _classCallCheck(this, Img);

    _this = _super.call(this, props);
    _this.setRef = _this.setRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Img, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateComponent();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateComponent();
    }
  }, {
    key: "updateComponent",
    value: function updateComponent() {
      // eslint-disable-line
      if (typeof window !== 'undefined' && typeof window.imageLazyLoading === 'function') {
        var imageLoadMode = this.getImageLoadMode(this.props);
        var className = this.getClass(null, imageLoadMode);
        window.imageLazyLoading(className, {
          loadMode: imageLoadMode
        }, this.ref);
      }
    }
  }, {
    key: "getClass",
    value: function getClass(propClassName, imageLoadMode) {
      var classPerform = {};

      if (imageLoadMode === LAZYLOAD) {
        classPerform = _defineProperty({}, LAZYLOAD_CLASS, true);
      }

      if (imageLoadMode === ONLOAD) {
        classPerform = _defineProperty({}, ONLOAD_CLASS, true);
      }

      return classNames(propClassName, classPerform);
    }
  }, {
    key: "getImageLoadMode",
    value: function getImageLoadMode(props) {
      var lazyload = props.lazyload,
          onload = props.onload;
      var imageLoadMode = null;

      if (this.hasLazyLoading(lazyload)) {
        imageLoadMode = LAZYLOAD;
      }

      if (this.hasOnLoad(onload)) {
        imageLoadMode = ONLOAD;
      }

      return imageLoadMode;
    }
  }, {
    key: "getImgTagProps",
    value: function getImgTagProps(_ref) {
      var src = _ref.src,
          srcSet = _ref.srcSet,
          className = _ref.className,
          alt = _ref.alt,
          onload = _ref.onload,
          lazyload = _ref.lazyload,
          lowEnd = _ref.lowEnd,
          mounted = _ref.mounted,
          carousel = _ref.carousel,
          preload = _ref.preload,
          srcFallback = _ref.srcFallback,
          imageProps = _objectWithoutProperties(_ref, ["src", "srcSet", "className", "alt", "onload", "lazyload", "lowEnd", "mounted", "carousel", "preload", "srcFallback"]);

      var props = {};
      var showSrc = this.showSrc({
        onload: onload,
        lazyload: lazyload,
        mounted: mounted,
        carousel: carousel,
        lowEnd: lowEnd
      });
      var imageLoadMode = this.getImageLoadMode({
        onload: onload,
        lazyload: lazyload
      });
      Object.assign(props, imageProps, {
        src: showSrc ? this.buildSrc(src) : DEFAULT_SRC,
        srcSet: showSrc && srcSet ? this.buildSrcSet(srcSet) : undefined,
        className: this.getClass(className, imageLoadMode),
        'data-src': !showSrc ? this.buildSrc(src) : undefined,
        'data-srcset': !showSrc && srcSet ? this.buildSrcSet(srcSet) : null,
        'data-src-fallback': srcFallback ? this.buildSrc(srcFallback) : undefined
      });

      if (this.hasLazyLoading(lazyload)) {
        // to avoid hydration warning in dev mode(race condition between react.hydrate & imageLazyLoading)
        props.suppressHydrationWarning = true;
      }

      return props;
    } // Builds the image source depending on the environment

  }, {
    key: "buildSrc",
    value: function buildSrc(src) {
      var trimmedSrc = src.trim();
      if (trimmedSrc.substring(0, 4) === 'http') return trimmedSrc;
      return this.context && this.context.images ? "".concat(this.context.images.prefix).concat(trimmedSrc) : DEFAULT_SRC;
    }
  }, {
    key: "buildSrcSet",
    value: function buildSrcSet(srcSet) {
      var _this2 = this;

      var noContext = !(this.context && this.context.images);
      if (noContext && !srcSet) return DEFAULT_SRC;
      if (noContext && srcSet) return srcSet; // since each src should be a url

      var sourceSets = [];
      srcSet.split(',').forEach(function (src) {
        if (src) {
          sourceSets.push("".concat(_this2.buildSrc(src)));
        }
      });
      return sourceSets.join(',');
    }
  }, {
    key: "showSrc",
    value: function showSrc(options) {
      var onload = options.onload,
          lazyload = options.lazyload,
          lowEnd = options.lowEnd;
      var show = true;

      if (this.hasLazyLoading(lazyload)) {
        if (this.wasMountedToCarousel(options)) {
          show = true;
        } else {
          show = false;
        }
      }

      if (this.hasOnLoad(onload)) {
        show = !!this.wasMountedToCarousel(options);
      }

      if (lowEnd) {
        show = true;
      }

      return show;
    }
  }, {
    key: "wasMountedToCarousel",
    value: function wasMountedToCarousel(options) {
      var carousel = options.carousel,
          mounted = options.mounted;
      return carousel && mounted;
    }
  }, {
    key: "hasOnLoad",
    value: function hasOnLoad(onload) {
      return onload === 'on';
    }
  }, {
    key: "hasLazyLoading",
    value: function hasLazyLoading(lazyload) {
      return lazyload === 'on';
    }
  }, {
    key: "hasPreload",
    value: function hasPreload(preload, lazyload, onload) {
      return preload && !this.hasLazyLoading(lazyload) && !this.hasOnLoad(onload);
    }
  }, {
    key: "setRef",
    value: function setRef(ref) {
      this.ref = ref;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          alt = _this$props.alt,
          onload = _this$props.onload,
          lazyload = _this$props.lazyload,
          preload = _this$props.preload;
      return _jsx(React.Fragment, {}, void 0, this.hasPreload(preload, lazyload, onload) && _jsx(ImagePreload, {
        href: this.buildSrc(this.props.src)
      }), /*#__PURE__*/React.createElement("img", _extends({
        key: "image",
        ref: this.setRef
      }, this.getImgTagProps(this.props), {
        alt: alt
      })), (this.hasLazyLoading(lazyload) || this.hasOnLoad(onload)) && _ref2);
    }
  }]);

  return Img;
}(React.PureComponent);

Img.defaultProps = {
  lazyload: 'on',
  onload: 'off',
  mounted: false,
  carousel: false,
  srcFallback: null,
  srcSet: null,
  className: null,
  lowEnd: false,
  preload: false,
  decoding: 'async'
};
Img.contextTypes = {
  images: PropTypes.object
};
module.exports = Img;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

var React = __webpack_require__(0);

var Script = __webpack_require__(6);

var _ref = /*#__PURE__*/_jsx(Script, {
  src: "@frontend-performance/image-lazy-loading/src.js",
  on: "now",
  inline: true
});

var ImageLoader = function ImageLoader() {
  return _ref;
};

module.exports = ImageLoader;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("frontend-script");

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

/**
 * Module dependencies
 */
var React = __webpack_require__(0);

var Head = __webpack_require__(8);

/**
 * ImagePreload
 */
var ImagePreload = function ImagePreload(_ref) {
  var href = _ref.href;
  return _jsx(Head, {}, void 0, _jsx("link", {
    rel: "preload",
    href: href,
    as: "image"
  }));
};

/**
 * Expose ImagePreload
 */
module.exports = ImagePreload;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = require("react-declarative-head");

/***/ })
/******/ ]);
//# sourceMappingURL=Image.js.map